<div class="ctx" [class.ctx--static]="!canSwitch">
  <!-- Desktop: plain-text trigger opening a hover/click dropdown -->
  <div class="dropdown d-none d-md-block">
    <button type="button" class="ctx__btn" id="contextSwitcher"
      [attr.data-bs-toggle]="canSwitch ? 'dropdown' : null" aria-expanded="false" [disabled]="!canSwitch">
      <ng-container *ngTemplateOutlet="triggerInner"></ng-container>
    </button>
    <ul class="dropdown-menu company-menu" aria-labelledby="contextSwitcher">
      <ng-container *ngTemplateOutlet="orgList"></ng-container>
    </ul>
  </div>

  <!-- Mobile: same plain-text trigger, opens a centered modal -->
  <button type="button" class="ctx__btn d-md-none" (click)="canSwitch && (mobileOpen = true)" [disabled]="!canSwitch">
    <ng-container *ngTemplateOutlet="triggerInner"></ng-container>
  </button>
</div>

<ng-template #triggerInner>
  <span class="ctx__chip">
    <img *ngIf="image" [src]="image" alt="" class="ctx__img">
    <span *ngIf="!image" class="ctx__img ctx__img--fallback"><i class="fa fa-building"></i></span>
  </span>
  <span class="ctx__label">{{ displayLabel }}</span>
  <i *ngIf="showChevron" class="fa fa-angle-down ctx__caret" aria-hidden="true"></i>
</ng-template>

<!-- One selectable bureau row: name, set-default checkbox, active check -->
<ng-template #flyoutBureau let-company="company" let-bureau="bureau">
  <a href="javascript:void(0);" class="dropdown-item ctx-flyout__item"
    [class.ctx-flyout__item--active]="isActive(company.id, bureau.id)"
    (click)="choose(company.id, company.name, bureau.id, bureau.name)">
    <span class="ctx-flyout__name">{{bureau.name}}</span>
    <div class="checkbox" title="Set as default">
      <input class="approval-check" name="default-bureau-{{company.id}}-{{bureau.id}}" type="checkbox"
        [checked]="isDefault(company.id, bureau.id)"
        (change)="setDefault(company.id, bureau.id, $event)" (click)="$event.stopPropagation()">
      <label for="default-bureau-{{company.id}}-{{bureau.id}}"></label>
    </div>
    <i class="fa fa-check ctx-flyout__check" *ngIf="isActive(company.id, bureau.id)" aria-hidden="true"></i>
  </a>
</ng-template>

<!-- The company's Grants & Sponsorships scope, when it has access -->
<ng-template #flyoutGrants let-company="company">
  <a href="javascript:void(0);" class="dropdown-item ctx-flyout__item"
    [class.ctx-flyout__item--active]="isActive(company.id, GRANTS_BUREAU_ID)"
    (click)="chooseGrants(company)">
    <span class="ctx-flyout__name">{{GRANTS_BUREAU_NAME}}</span>
    <div class="checkbox" title="Set as default">
      <input class="approval-check" name="default-bureau-{{company.id}}-grants" type="checkbox"
        [checked]="isDefault(company.id, GRANTS_BUREAU_ID)"
        (change)="setDefault(company.id, GRANTS_BUREAU_ID, $event)" (click)="$event.stopPropagation()">
      <label for="default-bureau-{{company.id}}-grants"></label>
    </div>
    <i class="fa fa-check ctx-flyout__check" *ngIf="isActive(company.id, GRANTS_BUREAU_ID)" aria-hidden="true"></i>
  </a>
</ng-template>

<!-- Company / bureau options: shared by the desktop dropdown and the mobile modal -->
<ng-template #orgList>
  <ng-template ngFor let-company [ngForOf]="companies">
    <li class="dropdown-submenu" *ngIf="authenticationService.is_staff() || companyScopeCount(company) > 0">
      <div *ngIf="showCompanySubmenu(company); then bureauActive; else notBureauActive"></div>
      <ng-template #bureauActive>
        <a href="javascript:void(0);" class="dropdown-item" [class.ctx-company--active]="isActiveCompany(company.id)" tabindex="-1">
          <i class="fa fa-building fa-fw"></i>
          {{company.name}}
          <i class="fa fa-angle-right"></i>
        </a>
      </ng-template>
      <ng-template #notBureauActive>
        <a href="javascript:void(0);" class="dropdown-item" [class.ctx-company--active]="isActiveCompany(company.id)" tabindex="-1" (click)="directSelectCompanyScope(company)">
          <i class="fa fa-building fa-fw"></i>
          {{company.name}}
          <i class="fa fa-angle-right"></i>
        </a>
      </ng-template>
      <ul class="dropdown-menu" *ngIf="!company.has_division && showCompanySubmenu(company)">
        <li *ngFor="let bureau of visibleBureaus(company)">
          <ng-container *ngTemplateOutlet="flyoutBureau; context: {company: company, bureau: bureau}"></ng-container>
        </li>
        <li *ngIf="companyHasGrantsAccess(company)">
          <ng-container *ngTemplateOutlet="flyoutGrants; context: {company: company}"></ng-container>
        </li>
      </ul>
      <ul class="dropdown-menu" *ngIf="company.has_division && showCompanySubmenu(company)">
        <li class="dropdown-submenu" *ngFor="let division of company.divisions">
          <a href="javascript:void(0);" class="dropdown-item" tabindex="-1">
            <i class="fa fa-building fa-fw"></i>
            {{division.name}}
            <i class="fa fa-angle-right"></i>
          </a>
          <ul class="dropdown-menu">
            <ng-template ngFor let-bureau [ngForOf]='visibleBureaus(company)'>
              <li *ngIf="bureau.division_id===division.id">
                <ng-container *ngTemplateOutlet="flyoutBureau; context: {company: company, bureau: bureau}"></ng-container>
              </li>
            </ng-template>
          </ul>
        </li>
        <li *ngIf="companyHasGrantsAccess(company)">
          <ng-container *ngTemplateOutlet="flyoutGrants; context: {company: company}"></ng-container>
        </li>
      </ul>
    </li>
  </ng-template>
</ng-template>

<!-- Mobile-only list: each company is a section header; its bureaus are tappable
     rows grouped in a card. Tapping a row switches to it; the current bureau is
     marked with a flush-right check. (Desktop keeps the hover-flyout #orgList.) -->
<ng-template #mobileOrgList>
  <ng-template ngFor let-company [ngForOf]="companies">
    <ng-container *ngIf="authenticationService.is_staff() || companyScopeCount(company) > 0">
      <div class="ctx-group__head"><i class="fa fa-building" aria-hidden="true"></i><span>{{company.name}}</span></div>

      <div class="ctx-group" *ngIf="!company.has_division">
        <button type="button" class="ctx-row" *ngFor="let bureau of visibleBureaus(company)"
          [class.ctx-row--active]="isActive(company.id, bureau.id)"
          (click)="choose(company.id, company.name, bureau.id, bureau.name)">
          <span class="ctx-row__name">{{bureau.name}}</span>
          <i class="fa fa-check ctx-row__check" *ngIf="isActive(company.id, bureau.id)" aria-hidden="true"></i>
        </button>
        <button type="button" class="ctx-row" *ngIf="companyHasGrantsAccess(company)"
          [class.ctx-row--active]="isActive(company.id, GRANTS_BUREAU_ID)"
          (click)="chooseGrants(company)">
          <span class="ctx-row__name">{{GRANTS_BUREAU_NAME}}</span>
          <i class="fa fa-check ctx-row__check" *ngIf="isActive(company.id, GRANTS_BUREAU_ID)" aria-hidden="true"></i>
        </button>
      </div>

      <ng-container *ngIf="company.has_division">
        <ng-template ngFor let-division [ngForOf]="company.divisions">
          <div class="ctx-group__subhead">{{division.name}}</div>
          <div class="ctx-group">
            <ng-template ngFor let-bureau [ngForOf]="visibleBureaus(company)">
              <button type="button" class="ctx-row" *ngIf="bureau.division_id === division.id"
                [class.ctx-row--active]="isActive(company.id, bureau.id)"
                (click)="choose(company.id, company.name, bureau.id, bureau.name)">
                <span class="ctx-row__name">{{bureau.name}}</span>
                <i class="fa fa-check ctx-row__check" *ngIf="isActive(company.id, bureau.id)" aria-hidden="true"></i>
              </button>
            </ng-template>
          </div>
        </ng-template>
        <div class="ctx-group" *ngIf="companyHasGrantsAccess(company)">
          <button type="button" class="ctx-row"
            [class.ctx-row--active]="isActive(company.id, GRANTS_BUREAU_ID)"
            (click)="chooseGrants(company)">
            <span class="ctx-row__name">{{GRANTS_BUREAU_NAME}}</span>
            <i class="fa fa-check ctx-row__check" *ngIf="isActive(company.id, GRANTS_BUREAU_ID)" aria-hidden="true"></i>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-template>

<!-- Mobile: centered modal with the company / bureau options -->
<div class="ctx-modal-overlay d-md-none" *ngIf="mobileOpen" (click)="mobileOpen = false">
  <div class="ctx-modal" (click)="$event.stopPropagation()">
    <div class="ctx-modal__header">
      <h5 class="ctx-modal__title">Switch organization</h5>
      <button type="button" class="ctx-modal__close" (click)="mobileOpen = false" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="ctx-modal__body">
      <ng-container *ngTemplateOutlet="mobileOrgList"></ng-container>
    </div>
  </div>
</div>
